var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Build_White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 15C7.33333 15 5.91667 14.4167 4.75 13.25C3.58333 12.0833 3 10.6667 3 9C3 8.66667 3.025 8.33333 3.075 8C3.125 7.66667 3.21667 7.35 3.35 7.05C3.43333 6.88333 3.5375 6.75833 3.6625 6.675C3.7875 6.59167 3.925 6.53333 4.075 6.5C4.225 6.46667 4.37917 6.47083 4.5375 6.5125C4.69583 6.55417 4.84167 6.64167 4.975 6.775L7.6 9.4L9.4 7.6L6.775 4.975C6.64167 4.84167 6.55417 4.69583 6.5125 4.5375C6.47083 4.37917 6.46667 4.225 6.5 4.075C6.53333 3.925 6.59167 3.7875 6.675 3.6625C6.75833 3.5375 6.88333 3.43333 7.05 3.35C7.35 3.21667 7.66667 3.125 8 3.075C8.33333 3.025 8.66667 3 9 3C10.6667 3 12.0833 3.58333 13.25 4.75C14.4167 5.91667 15 7.33333 15 9C15 9.38333 14.9667 9.74583 14.9 10.0875C14.8333 10.4292 14.7333 10.7667 14.6 11.1L19.65 16.1C20.1333 16.5833 20.375 17.175 20.375 17.875C20.375 18.575 20.1333 19.1667 19.65 19.65C19.1667 20.1333 18.575 20.375 17.875 20.375C17.175 20.375 16.5833 20.125 16.1 19.625L11.1 14.6C10.7667 14.7333 10.4292 14.8333 10.0875 14.9C9.74583 14.9667 9.38333 15 9 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildWhite);
export default __webpack_public_path__ + "static/media/build_white.e4f397f95579c19548681baf4fac1551.svg";
export { ForwardRef as ReactComponent };